<div class="profile-selection-container">
  <h2 class="modal-title">Selecciona tu perfil</h2>
  
  <!-- Loader -->
  <div *ngIf="loading" class="text-center p-3">
    <div class="spinner">
      <span>Cargando perfiles...</span>
    </div>
  </div>
  
  <!-- Error message -->
  <div *ngIf="errorMessage" class="error-message p-3">
    <p>{{ errorMessage }}</p>
    <button mat-button color="primary" (click)="loadProfiles()">
      Reintentar
    </button>
  </div>
  
  <!-- Profile list -->
  <div *ngIf="!loading && !errorMessage && profileList && profileList.length > 0" class="profile-list">
    <div class="profiles-container">
      <div class="profile-option" 
           *ngFor="let profile of profileList" 
           [class.selected]="isProfileSelected(profile)"
           [class.current]="isCurrentProfile(profile)"
           (click)="onSelectProfile(profile)">
        <div class="profile-icon-container">
          <img src="assets/images/salud/icons/face.svg" alt="face-icon" class="profile-icon" />
        </div>
        <div class="profile-info">
          <div class="profile-name">{{ profile.Name }}</div>
        </div>
      </div>
      <!-- Botón para añadir perfil -->
      <div class="profile-option add-profile" (click)="addNewProfile()">
        <div class="profile-icon-container">
          <img src="assets/images/salud/icons/add_circle.svg" alt="add-profile-icon" class="profile-icon" />
        </div>
        <div class="profile-info">
          <div class="profile-name">Añadir perfil</div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- No profiles message -->
  <div *ngIf="!loading && !errorMessage && (!profileList || profileList.length === 0)" class="no-profiles-message p-3">
    <p>No tienes perfiles médicos disponibles.</p>
    <button mat-button color="primary" (click)="addNewProfile()">
      Crear perfil médico
    </button>
  </div>
  
  <!-- Action buttons -->
  <div class="button-container mt-3">
    <button (click)="cancel()" class="cancel-button">Cancelar</button>
    <button class="select-profile-button" [disabled]="!selectedProfile" (click)="selectProfile()">
      Seleccionar
    </button>
  </div>
</div> 